module.exports = __webpack_public_path__ + "img/tway-logotipo-gris.28cc097a.svg";